import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import DatePicker from "react-datepicker";
import useTitanApp from "../../../../hooks/useTitanApp";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import {
  rescheduleServices,
  setCurrentPharmacyServices,
  setEligibilityStageScrollPosition,
  setInterventionStageScrollPosition,
  setListViewGridScrollPosition,
  setScrollPosition,
} from "../../../../dispatchers/pharmacyServiceDispatchers";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showError } from "../../../../components/ToastedMessage/ToastedMessage";

export default function RescheduleNms({
  view,
  setShowReschedule,
  rescheduleQueue,
  setCurrentSmsQueue,
  setCurrentReSmsQueue,
  setCurrentInterventionQueue,
  setCurrentDeclineQueue,
  setCurrentRescheduleQueue,
  setCurrentPdsQueue,
  setCurrentOrbitQueue,
  setChecksCount,
}) {
  const { appState, pharmacyServiceState } = useTitanApp();
  const { darkMode } = appState || {};
  const { pharmacyServices } = pharmacyServiceState || {};
  const currentHour = new Date().getHours();
  const currentMinute = new Date().getMinutes();
  const [popupDateTime, setPopupDateTime] = useState(new Date());

  const showToast = (message) => {
    toast.success(`${message}`, {
      className: "services-toast",
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 3000,
      theme: darkMode ? "dark" : "light",
    });
  };

  function rescheduleBulkServices() {
    try {
      const parsedDate = moment(
        popupDateTime,
        "ddd MMM DD YYYY HH:mm:ss [GMT] ZZ (z)"
      );

      const formattedDateTime = parsedDate.format("YYYY-MM-DDTHH:mm:ss[Z]");
      const formattedDateTimeToReplace = parsedDate.format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      rescheduleServices({
        data: rescheduleQueue,
        rescheduleDate: formattedDateTime,
      }).then(() => {
        const newData = pharmacyServices?.map((stage) => ({
          ...stage,
          sortedServices: stage?.sortedServices?.map((service) => ({
            ...service,
            clinicalServices: service?.clinicalServices.map(
              (clinicalService) => ({
                ...clinicalService,
                stages: clinicalService?.stages.map((stage) => ({ ...stage })),
              })
            ),
          })),
        }));

        rescheduleQueue?.forEach((queueItem) => {
          newData?.forEach((stage) => {
            stage?.sortedServices?.forEach((serviceGroup) => {
              serviceGroup?.clinicalServices?.forEach((clinicalService) => {
                if (clinicalService._id === queueItem) {
                  let stageFound = false;
                  clinicalService.stages = clinicalService?.stages?.map(
                    (stage) => {
                      if (
                        !stageFound &&
                        stage.clinicalServiceStageStatus === 0
                      ) {
                        stageFound = true;
                        return {
                          ...stage,
                          startDate: formattedDateTimeToReplace,
                        };
                      }
                      return stage;
                    }
                  );
                }
              });
            });
          });
        });

        if (view === "kanban") {
          setCurrentPharmacyServices(newData);

          const stagesWrapper = document.querySelector(".stages-wrapper");
          if (stagesWrapper) {
            setScrollPosition(stagesWrapper.scrollLeft);
          }
          const stageEligible = document.getElementById("stage_Eligible");
          if (stageEligible) {
            setEligibilityStageScrollPosition(stageEligible.scrollTop);
          }
          const stageIntervention =
            document.getElementById("stage_Intervention");
          if (stageIntervention) {
            setInterventionStageScrollPosition(stageIntervention.scrollTop);
          }
        } else {
          setShowReschedule(false);
        }

        showToast(
          `Record${
            rescheduleQueue.length > 1 ? "s have" : " has"
          } been rescheduled successfully!`
        );
        setCurrentSmsQueue([]);
        setCurrentReSmsQueue([]);
        setCurrentInterventionQueue([]);
        setCurrentOrbitQueue([]);
        setCurrentDeclineQueue([]);
        setCurrentRescheduleQueue([]);
        setCurrentPdsQueue([]);
        setChecksCount(0);
      });
    } catch (error) {
      showError("Something went wrong.");
    }
  }
  return (
    <Draggable bounds="parent" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper className="callScreenDialog rescheduleDialog">
        <div className="callScreen_dialog_wrapper" id="callScreen-dialog-title">
          <div className="rescheduling">
            <div className="top-bar">
              <div className="patient-info">
                <div className="d-flex">
                  <p>Reschedule</p>
                </div>
              </div>

              <RxCross2
                color={darkMode ? "#fff" : "#0a0a0a"}
                size={15}
                className="collapse-icon"
                onClick={() => {
                  setShowReschedule(false);
                }}
              />
            </div>
            <div className="body">
              <div className="options-wrapper">
                <div className="option">
                  <div className="flex">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="24" height="24" rx="12" fill="black" />
                      <path
                        d="M9.85714 12.7143C10.2516 12.7143 10.5714 12.3945 10.5714 12C10.5714 11.6055 10.2516 11.2857 9.85714 11.2857C9.46265 11.2857 9.14286 11.6055 9.14286 12C9.14286 12.3945 9.46265 12.7143 9.85714 12.7143Z"
                        fill="white"
                      />
                      <path
                        d="M10.5714 14.1429C10.5714 14.5373 10.2516 14.8571 9.85714 14.8571C9.46265 14.8571 9.14286 14.5373 9.14286 14.1429C9.14286 13.7484 9.46265 13.4286 9.85714 13.4286C10.2516 13.4286 10.5714 13.7484 10.5714 14.1429Z"
                        fill="white"
                      />
                      <path
                        d="M12 12.7143C12.3945 12.7143 12.7143 12.3945 12.7143 12C12.7143 11.6055 12.3945 11.2857 12 11.2857C11.6055 11.2857 11.2857 11.6055 11.2857 12C11.2857 12.3945 11.6055 12.7143 12 12.7143Z"
                        fill="white"
                      />
                      <path
                        d="M12.7143 14.1429C12.7143 14.5373 12.3945 14.8571 12 14.8571C11.6055 14.8571 11.2857 14.5373 11.2857 14.1429C11.2857 13.7484 11.6055 13.4286 12 13.4286C12.3945 13.4286 12.7143 13.7484 12.7143 14.1429Z"
                        fill="white"
                      />
                      <path
                        d="M14.1429 12.7143C14.5373 12.7143 14.8571 12.3945 14.8571 12C14.8571 11.6055 14.5373 11.2857 14.1429 11.2857C13.7484 11.2857 13.4286 11.6055 13.4286 12C13.4286 12.3945 13.7484 12.7143 14.1429 12.7143Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17 8.78571C17 7.79949 16.2005 7 15.2143 7H8.78571C7.79949 7 7 7.79949 7 8.78571V15.2143C7 16.2005 7.79949 17 8.78571 17H15.2143C16.2005 17 17 16.2005 17 15.2143V8.78571ZM7.71429 9.85714H16.2857V15.2143C16.2857 15.806 15.806 16.2857 15.2143 16.2857H8.78571C8.19398 16.2857 7.71429 15.806 7.71429 15.2143V9.85714ZM8.78571 7.71429H15.2143C15.806 7.71429 16.2857 8.19398 16.2857 8.78571V9.14286H7.71429V8.78571C7.71429 8.19398 8.19398 7.71429 8.78571 7.71429Z"
                        fill="white"
                      />
                    </svg>

                    <p>Date/Time</p>
                  </div>

                  <DatePicker
                    className="widgetDatePicker"
                    onChange={(date) => {
                      setPopupDateTime(date);
                    }}
                    showTimeSelect
                    selected={popupDateTime}
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="dd/MM/yyyy h:mm aa"
                    minDate={new Date()}
                    minTime={
                      popupDateTime &&
                      popupDateTime.toDateString() === new Date().toDateString()
                        ? new Date().setHours(
                            currentHour,
                            currentMinute + 15,
                            0,
                            0
                          )
                        : new Date().setHours(0, 0, 0, 0)
                    }
                    maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                  />
                </div>
              </div>

              <div className="calling-footer">
                <button className="done" onClick={rescheduleBulkServices}>
                  <p>Done</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </Draggable>
  );
}
